import type { CSSObject } from 'tss-react';
import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';
import type { BreakpointName } from '@/styles/viewportSize';

const lightBlueFractalImageDesktop =
  '/cmsAssets/assets/img/BackgroundImages/LightBlueFractalDesktop.png';
const lightBlueFractalImageMobile =
  '/cmsAssets/assets/img/BackgroundImages/LightBlueFractalDesktop.png';
const offWhiteFractalDesktop =
  '/cmsAssets/assets/img/BackgroundImages/OffWhiteFractalDesktop.png';
const offWhiteFractalMobile =
  '/cmsAssets/assets/img/BackgroundImages/OffWhiteFractalDesktop.png';

interface Props {
  screenSizesToHide?: BreakpointName[];
}

const useStyles = makeStyles<Props>({ name: 'MuiSection' })(
  ({ brandColors, breakpoints, typography }, { screenSizesToHide }) => ({
    LightBlueFractal: {
      backgroundImage: `url('${lightBlueFractalImageDesktop}')`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        backgroundImage: `url('${lightBlueFractalImageMobile}')`,
      },
    },
    OffWhiteFractal: {
      backgroundImage: `url('${offWhiteFractalDesktop}')`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        backgroundImage: `url('${offWhiteFractalMobile}')`,
      },
    },
    OffWhite: {
      backgroundColor: brandColors.offWhite,
    },
    grayLine: {
      borderBottom: `${typography.pxToRem(1)} solid ${brandColors.gray}`,
    },
    White: {
      backgroundColor: brandColors.white,
    },
    LightBlue: {
      backgroundColor: brandColors.chargeBlue,
    },
    hide: {
      display: 'none',
    },

    hideOnScreenSizes: (['xs', 'sm', 'md', 'lg', 'xl'] as const).reduce(
      (acc, bp) => {
        acc[breakpoints.only(bp)] = {
          display: screenSizesToHide?.includes(bp) ? 'none' : 'inherit',
        };
        return acc;
      },
      {} as Record<string, CSSObject>
    ),
  })
);

export default useStyles;
